module.exports = __webpack_public_path__ + "img/reverseTrapezoid.1f77193f.svg";